
export class ProduktSearchRequestDTO   {

    id: number;
    produktnamn: string;
    produktgrupp: string;
    handelssortiment: string;
    sortimentskod: string;
    tradslag: string;
    beteckning: string;
    aktiv: boolean;

    constructor() {
        this.id = undefined;
        this.produktnamn = undefined;
        this.produktgrupp = undefined;
        this.handelssortiment = undefined;
        this.sortimentskod = undefined;
        this.tradslag = undefined;
        this.beteckning = undefined;
        this.aktiv = undefined;
    }
}
